import { render, staticRenderFns } from "./gamerole.vue?vue&type=template&id=7155b7cc&scoped=true"
import script from "./gamerole.vue?vue&type=script&lang=js"
export * from "./gamerole.vue?vue&type=script&lang=js"
import style0 from "./gamerole.vue?vue&type=style&index=0&id=7155b7cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7155b7cc",
  null
  
)

export default component.exports